export const mutations = {

    storeCurrentSocietyRequest(state, data){
        state.currentSocietyRequest = data
    },

    resetState(state) {
        state.currentSocietyRequest = {}
    }

};
